var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ObservationPage',{on:{"back":_vm.backToAutoControl,"deleted":_vm.backToAutoControl}})
}
var staticRenderFns = []

export { render, staticRenderFns }